import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { apiURL, fetchGeneralSetting, fetchLedgerBalance } from "./API";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  getRowData,
  getYMDfromMDY,
  getYMDfromDMY,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import readXlsxFile from "read-excel-file";
import { fetchBillSetting, fetchImportDetails } from "./API";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";

class CarryForwardLedgerBalance extends Component {
  state = {
    ARD: null,
  };
  //#region Component
  componentDidMount() {
    document.title = "RA : Carry Forward Ledger Balance";
    this.getInvoicePrefixFormate();
  }
  //#endregion Component

  //#region  function

  getInvoicePrefixFormate = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "InvoiceSettingList",
        bint_acid: localStorage.getItem("acid"),
        bolInvoiceFormatList: true,
      };
      fetchBillSetting(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let InvoiceFormat = res.data.InvoiceSettingList.map((row) => {
            return [row.vac_invoiceprefix, row.vac_invoicetype];
          });
          this.setState({
            dataLoadStatus,
            InvoiceFormat,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in getInfo.", error);
        });
    });
  };

  carryForwardLedgerBalance = () => {
    let dataLoadStatus = false;
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "ProcessClosingBalance",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
      };
      fetchLedgerBalance(reqData)
        .then((res) => {
          dataLoadStatus = true;
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState(
              {
                dataLoadStatus,
              },
              () => {}
            );
          }
        })
        .catch((error) => {
          console.log(
            "Unknown error occurred in carryForwardLedgerBalance.",
            error
          );
        });
    });
    return true;
  };

  ProcessCarryForwardLedgerBalance = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree="Yes"
          labelDisagree="No"
          alertTitle={
            "Do you want Start Process of Carry Forward Ledger Balance from " +
            localStorage.getItem("ACY") +
            "-" +
            (Number(localStorage.getItem("ACY")) + 1).toString().slice(-2) +
            " to " +
            (Number(localStorage.getItem("ACY")) + 1) +
            "-" +
            (Number(localStorage.getItem("ACY")) + 2).toString().slice(-2) +
            " ?"
          }
          alertMessage=""
          handleOnClickYes={() => {
            return this.carryForwardLedgerBalance();
          }}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  //#endregion funtion

  //#region handle

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  //#endregion handle
  render() {
    return (
      <div>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          marginRight={1}
        >
          <Grid item>
            <label style={{ fontSize: "30px", color: "#515151" }}>
              <b>Carry Forward Ledger Balance</b>
            </label>
          </Grid>
        </Grid>
        <form>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={3}
            marginTop={1}
          >
            <Grid item style={{ display: "flex", flexDirection: "row" }}>
              <CtBtn
                label="Carry Forward Ledger Balance"
                onClick={this.ProcessCarryForwardLedgerBalance}
              />
            </Grid>
          </Grid>
          <Grid item>
            <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
              {this.state.ARD}
            </Box>
          </Grid>
        </form>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(CarryForwardLedgerBalance))));
